<template>
	<div class="card-content">
		<img :src="image" v-show='image'>
		<div class="button">
		    <input type="file" name="imageback" @change="selectCard(type,$event)" id="imageback" accept="image/*">
		</div>
		<div class="load-back" v-if='loading'>
   	    	<div class="loading">
   	    	</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
       	}
	},
	props:['image','type','loading'],
	components:{
		
	},
	created(){
	},
	computed: {
    },
	watch:{
	},
	methods:{
		selectCard(value,event){
			var files = event.target.files,file;
            if (!(files && files.length > 0)) {
                return;
            }
            // 获取目前上传的文件
            file = files[0];
            if (file.size > 5000000) {
            	this.$Message.error('请选择小于5M的图片');
            	event.target.value = null;
            	return;
            }
			this.$emit('select',this.type,file);
			event.target.value = null;
		}
	},
}
</script>

<style lang="scss" scoped>
.load-back{
	position:absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(125,125,125,0.6);
}
.loading{
	position:absolute;
	left: 40%;
	top: 60px;
	animation:spinner-rotate 0.8s infinite linear;
	border: 4px solid transparent;
	border-radius: 50%;
	border-top-color: white;
    border-left-color: white;
    // border-bottom-color: 1rem;
    height: 40px;
    width: 40px;
}
@keyframes spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.card-content {
	position: relative;
	margin-top: 5px;
	width: 100%;
	height: 160px;
	text-align: center;
	// background-color: orange;
	img {
		
		float: left;
		width: 100%;
		height: 100%;
	}
	.button {
		cursor: pointer;
		display: inline-block;
		height: 40px;
		width: 40px;
		background-image: url(../../assets/add-p.png);
		background-repeat: no-repeat;
		background-size: contain;
		background-color: transparent;
		position: absolute;
		left: 50%;
    	top: 50%;
    	transform: translate(-50%, -50%);

		input[type='file'] {
			cursor: pointer;
			margin: 0;
			opacity: 0;
			width: 100%;
			height: 100%;
		}
	}
}

</style>